// extracted by mini-css-extract-plugin
module.exports = {"redaktorvarsler":"Redaktorvarsler_redaktorvarsler__ESP21","liste":"Redaktorvarsler_liste__ML7ay"};